import React from "react";
import styled from "styled-components";

import { getTagValueFromResource, SystemTag } from "@examspark/common";
import {
  Button,
  Callout,
  colorFromTheme,
  Toolbar,
  VSpace,
} from "@examspark/common-ui";
import {
  IconCautionSolid,
  IconGearLine,
} from "@examspark/common-ui/dist/components/icons";
import { ActivityEditorConfig, Resource } from "@examspark/types";

import { useModal } from "../../hooks";
import DownloadExamButton from "../exams/DownloadExamButton";
import PreviewExamButton from "../exams/PreviewExamButton";
import PrintExamButton from "../exams/PrintExamButton";

import ActivityKioskUrl from "./ActivityKioskUrl";
import ActivityResultsRoute from "./ActivityResultsRoute";
import ActivitySettingsModal from "./ActivitySettingsModal";

const KioskBanner = styled.div`
  border: solid 1px #ddd;
  background-color: #efeef4;
  padding: 1rem;
  border-radius: 0.5rem;
`;

const StyledCautionIcon = styled(IconCautionSolid)`
  height: 16px;
  fill: ${colorFromTheme("caution")};
`;

const Activity = (props: {
  examConfig: Resource;
  showAttempts: boolean;
  forbidStudentData?: boolean;
  hideResultsByObjectives?: boolean;
  allowDelete?: boolean;
  allowDownload?: boolean;
  allowEdit?: boolean;
  allowPrint?: boolean;
  showShuffleItems?: boolean;
  activityEditorConfig?: ActivityEditorConfig; // Define the type according to your needs
  onDelete?: () => void;

  hideAllActions?: boolean;
  hideDigitalDelivery?: boolean;
}) => {
  const settingsModal = useModal();
  const { examConfig } = props;
  const examConfigLtiContextId = getTagValueFromResource(
    examConfig,
    SystemTag.LtiContextId,
  );

  return (
    <>
      {/* {props.activityEditorConfig && (
        <ActivityEditorModal
          examId={examId}
          {...activityEditorModal.modalProps}
          editorConfig={props.activityEditorConfig}
          // onBeforeSave={({ data, type }) => {
          //   if (type === "create") {
          //     data.isUnlisted = true;
          //   }
          // }}
          // onSave={handleSave}
        />
      )} */}
      <ActivitySettingsModal
        examConfigKey={examConfig}
        {...settingsModal.modalProps}
        onUpdate={settingsModal.close}
      />
      <VSpace size="3rem">
        {props.hideDigitalDelivery ? (
          <Callout indicatorColor="caution" icon={<StyledCautionIcon />}>
            This activity is not available for digital delivery.
          </Callout>
        ) : (
          props.examConfig &&
          !examConfigLtiContextId && (
            <KioskBanner>
              <ActivityKioskUrl examConfig={props.examConfig} />
            </KioskBanner>
          )
        )}
        {/* toolbar got moved to a PageMenu in the new layout */}
        {props.hideAllActions ? null : (
          <Toolbar>
            <PreviewExamButton exam={examConfig.resource ?? undefined} />
            {props.allowPrint && (
              <PrintExamButton
                flags={{
                  showShuffleItems: props.showShuffleItems,
                }}
                exam={
                  examConfig.resource?.id &&
                  examConfig.resource?.sk &&
                  examConfig.resource?.workspaceId
                    ? {
                        id: examConfig.resource?.id,
                        sk: examConfig.resource?.sk,
                        workspaceId: examConfig.resource?.workspaceId,
                      }
                    : undefined
                }
              />
            )}
            {props.allowDownload && (
              <DownloadExamButton exam={examConfig.resource} />
            )}
            <Button
              variant="outlined"
              title="Settings"
              icon={<IconGearLine />}
              onClick={(e) => {
                if (e.altKey) {
                  console.log(examConfig);
                  return;
                }

                settingsModal.open();
              }}
            >
              Settings
            </Button>
            {/* <Button
              variant="outlined"
              title="Settings"
              icon={<IconPencilLine />}
              onClick={(e) => {
                activityEditorModal.open();
              }}
            >
              Edit
            </Button> */}
          </Toolbar>
        )}
        {!props.hideDigitalDelivery && (
          <ActivityResultsRoute
            examConfig={examConfig}
            showAttempts={props.showAttempts}
            forbidStudentData={props.forbidStudentData}
            hideResultsByObjectives={props.hideResultsByObjectives}
          />
        )}
      </VSpace>
    </>
  );
};

export default Activity;
